document.addEventListener('DOMContentLoaded', function() {
  // Wähle das korrekte Header-Element, das die Klasse ".is-filled" erhält.
  const header = document.querySelector('store-header');
  const firstSection = document.querySelector('main > .shopify-section:first-of-type');

  // Wenn der Header nicht gefunden wird, beenden wir das Skript.
  if (!header) {
    return;
  }
  
  // SZENARIO A: Homepage mit transparent-fähiger Sektion
  if (firstSection && firstSection.hasAttribute('allow-transparent-header')) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            header.classList.remove('is-filled');
          } else {
            header.classList.add('is-filled');
          }
        });
      },
      { rootMargin: '-50px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(firstSection);
  } 
  
  // SZENARIO B: Fallback für alle anderen Seiten
  else {
    function handleScroll() {
      if (window.scrollY > 10) {
        header.classList.add('is-filled');
      } else {
        header.classList.remove('is-filled');
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
});